import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyActionConflictHistoryListRoute = lazy(() =>
  retry(() => import('app/pages/admin/NOA/ActionConflictHistory/List')));
const LazyActionConflictsListRoute = lazy(() => retry(() => import('app/pages/admin/NOA/ActionConflicts/List')));
const LazyActionConflictsShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/ActionConflicts/Show')));
const LazyAuditQueueWarningRoute = lazy(() => retry(() => import('app/pages/admin/NOA/AuditQueueWarning')));
const LazyBulkRemoveRoute = lazy(() => retry(() => import('app/pages/admin/NOA/BulkRemove')));
const LazyCoachableReportListRoute = lazy(() => retry(() => import('app/pages/admin/NOA/CoachableReport/List')));
const LazyCoachableReportShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/CoachableReport/Show')));
const LazySearchRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Search/List')));
const LazyHistoryShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/History/Show')));
const LazyInvalidFactorRoute = lazy(() => retry(() => import('app/pages/admin/NOA/PendingFactors/List')));
const LazyInvalidFactorShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/PendingFactors/Show')));
const LazyLorDesginationShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/PendingLorDesignation/Show')));
const LazyNextRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Next')));
// eslint-disable-next-line @stylistic/max-len
const LazyNoaAutomatedDecisionDataRoute = lazy(() => retry(() => import('app/pages/admin/NOA/NoaAutomationDecisionData')));
const LazyNoaErrorRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Error')));
const LazyMetricsRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Metrics')));
const LazyMissingLORRoute = lazy(() => retry(() => import('app/pages/admin/NOA/MissingLOR')));
const LazyListRoute = lazy(() => retry(() => import('app/pages/admin/NOA/List/NOAListTable')));
const LazySplitNOAsListRoute = lazy(() => retry(() => import('app/pages/admin/NOA/SplitNOAs/List')));
const LazySplitNOAsShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/SplitNOAs/Show')));
const LazyShowRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Show')));
const LazySuccessRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Success')));
const LazyMatchesListRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Matches/List')));
const LazyRedirectRoute = lazy(() => retry(() => import('app/pages/admin/NOA/Redirect')));

export const ActionConflictHistoryList = (props: ComponentProps) => <LazyActionConflictHistoryListRoute {...props} />;
export const ActionConflictsList = (props: ComponentProps) => <LazyActionConflictsListRoute {...props} />;
export const ActionConflictsShow = (props: ComponentProps) => <LazyActionConflictsShowRoute {...props} />;
export const ActionConflictHistory = (props: ComponentProps) => (
  <LazyHistoryShowRoute
    {...props}
    isConflictHistory
  />
);
export const AuditQueueWarning = (props: ComponentProps) => <LazyAuditQueueWarningRoute {...props} />;
export const BulkRemove = (props: ComponentProps) => <LazyBulkRemoveRoute {...props} />;
export const CoachableReportList = (props: ComponentProps) => <LazyCoachableReportListRoute {...props} />;
export const CoachableReportShow = (props: ComponentProps) => <LazyCoachableReportShowRoute {...props} />;
export const SearchList = (props: ComponentProps) => <LazySearchRoute {...props} />;
export const HistoryShow = (props: ComponentProps) => <LazyHistoryShowRoute {...props} />;
export const InvalidFactorList = (props: ComponentProps) => <LazyInvalidFactorRoute {...props} />;
export const InvalidFactorShow = (props: ComponentProps) => <LazyInvalidFactorShowRoute {...props} />;
export const LorDesignationShow = (props: ComponentProps) => <LazyLorDesginationShowRoute {...props} />;
export const Next = (props: ComponentProps) => <LazyNextRoute {...props} />;
export const NoaAutomationDecisionData = (props: ComponentProps) => <LazyNoaAutomatedDecisionDataRoute {...props} />;
export const NoaError = (props: ComponentProps) => <LazyNoaErrorRoute {...props} />;
export const Metrics = (props: ComponentProps) => <LazyMetricsRoute {...props} />;
export const MissingLOR = (props: ComponentProps) => <LazyMissingLORRoute {...props} />;
export const List = (props: ComponentProps) => <LazyListRoute {...props} />;
export const Show = (props: ComponentProps) => <LazyShowRoute {...props} />;
export const Success = (props: ComponentProps) => <LazySuccessRoute {...props} />;
export const SplitNOAsList = (props: ComponentProps) => <LazySplitNOAsListRoute {...props} />;
export const SplitNOAsShow = (props: ComponentProps) => <LazySplitNOAsShowRoute {...props} />;
export const MatchesList = (props: ComponentProps) => <LazyMatchesListRoute {...props} />;
export const Redirect = (props: ComponentProps) => <LazyRedirectRoute {...props} />;
